export enum SurveyState {
  START,
  POSITIVE,
  ISSUES,
  LOOKING_FOR_SOMETHING_ELSE,
  BETTER_PRICE_ELSEWHERE,
  PRICES_TOO_HIGH,
  MORE_INFO_NEEDED,
  INSUFFICIENT_REVIEWS,
  BOOKING_COMPLICATED,
  DONE,
}

export enum SurveyEvents {
  BACK,
  NEXT,
  DONE,
}

export interface SurveyStateBase {
  state: SurveyState;
  title?: string; // title different from survey title
  question: string;
  optionType: "none" | "radio" | "checkbox";
  options?: any[];
  prev: SurveyState | null; // if null it means that's the first state or undefinable
  showNext: boolean;
  showBack: boolean;
}

export interface SurveyStateRadio extends SurveyStateBase {
  optionType: "radio";
  options: { title: string; next: SurveyState }[];
  randomizeOptions: boolean;
}

export interface SurveyStateCheckbox extends SurveyStateBase {
  optionType: "checkbox";
  options: string[];
  next: SurveyState;
  randomizeOptions: boolean;
}

export type SurveyStateObject =
  | SurveyStateBase
  | SurveyStateRadio
  | SurveyStateCheckbox;
